import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faCalendar, faClock, faStethoscope, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
//import PaymentModal from "./PaymentModal";
import RescheduleModal from "./RescheduleModal.js";
import CancelModal from "./CancelModal.js";
import "./componentsCss/ScheduledProceduresModal.css";
import courtesy from "../assets/img/courtesy-selected.png";
import { formatDateDDMMYYYYHHMM } from "../utils/formats.js";

const ScheduledProceduresModal = ({
  patient,
  onClose,
  onRemove,
  onReschedule,
}) => {
 //const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const schedules = patient.schedules || [];
  const hasAnyProcedures = schedules.length > 0;

  //const handleClosePayment = () => setShowPaymentModal(false);

  const handleReschedule = (schedule) => {
    setSelectedSchedule(schedule);
    setShowRescheduleModal(true);
  };

  const handleCloseReschedule = () => setShowRescheduleModal(false);

  const handleCancel = (schedule) => {
    setSelectedSchedule(schedule);
    setShowCancelModal(true);
  };

  const handleCloseCancel = () => setShowCancelModal(false);

  const removeSchedule = (schedules, schedulesIds) => {
    onRemove(schedules, schedulesIds);
    console.log("IDs Scheduling removidos: ", schedulesIds);
    console.log("IDs Procedures removidos: ", schedules);
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="procedures-modal scheduled-procedures-modal">
          <div className="modal-header">
            <h2>Procedimentos Agendados - {patient.name}</h2>
            <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faX} />
            </button>
          </div>

          <div className="modal-content-scrollable">
            <div className="scheduled-procedures-list">
              {hasAnyProcedures ? (
                schedules.map((schedule) => {
                  const { id, scheduling_date, items } = schedule;

                  const dateFormatted = new Date(
                    scheduling_date
                  ).toLocaleDateString("pt-BR", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  });

                  const totalValue = items
                    .filter((item) => item.agreement === null)
                    .reduce(
                      (sum, item) => sum + parseFloat(item.selling_price || 0),
                      0
                    );

                  return (
                    <div key={id} className="scheduled-procedure-card">
                      <div className="scheduled-procedure-header">
                        <div className="scheduled-date-time">
                          <div className="scheduled-date">
                          <FontAwesomeIcon icon={faCalendar} />
                            <span>{dateFormatted}</span>
                          </div>
                        </div>
                      </div>

                      <ul className="scheduled-procedures">
                        {items.map((item, idx) => (
                          <li key={idx}>
                            <div className="scheduled-doctor">
                            <FontAwesomeIcon icon={faStethoscope} />
                              <span>
                                {item.professional_name ||
                                  "Profissional não informado"}
                              </span>
                            </div>
                            <strong>Procedimento:</strong>
                            <div className="scheduled-info-row">
                              <span
                                className="limit_caracters"
                                title={item.procedure_name}>
                                {item.procedure_name}
                              </span>
                              <span>
                                {item.courtesy ? (
                                  <img src={courtesy} width={50} alt="" />
                                ) : (
                                  ""
                                )}
                              </span>
                              <span>{formatDateDDMMYYYYHHMM(item.date_scheduling)}</span>
                              <span>{item.time_booked || "Sem horário"}</span>
                              <span className="procedure-price">
                                {item.agreement !== null
                                  ? item.agreement
                                  : "R$ " +
                                    parseFloat(item.selling_price || 0).toFixed(
                                      2
                                    ).replace('.', ',')}
                              </span>
                              <FontAwesomeIcon icon={faCheckCircle}
                                className={`status-icon status-${
                                  item.confirmed
                                    ? "confirmed"
                                    : item.cancel
                                    ? "cancelled"
                                    : "scheduled"
                                }`}
                              />
                            </div>
                          </li>
                        ))}
                      </ul>

                      <div className="scheduled-total">
                        <span>Valor Total:</span>
                        <span className="total-price">
                          R$ {totalValue.toFixed(2).replace('.', ',')}
                        </span>
                      </div>

                      <div className="scheduled-procedure-actions">
                        <button
                          className="reschedule-button"
                          onClick={() =>
                            handleReschedule({
                              procedures: items,
                              date: scheduling_date,
                            })
                          }
                          disabled={items.every(
                            (i) => i.cancel || i.confirmed
                          )}>
                          Reagendar
                        </button>

                        <button
                          className="cancel-appointment-button"
                          onClick={() =>
                            handleCancel({
                              procedures: items,
                              date: scheduling_date,
                            })
                          }
                          disabled={items.every(
                            (i) => i.cancel || i.confirmed
                          )}>
                          Cancelar
                        </button>

                        {/*Pagamento */}
                        {/*<button
                          className="payment-button"
                          onClick={() => handleOpenPayment(schedule)}
                          title="Realizar Pagamento">
                          <Receipt size={16} />
                          <span>Pagamento</span>
                        </button> */}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-scheduled-procedures">
                  <FontAwesomeIcon icon={faCalendar} />
                  <p>Nenhum procedimento agendado para este paciente.</p>
                  <button className="schedule-new-button" onClick={onClose}>
                    Agendar Novo Procedimento
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button className="cancel-button" onClick={onClose}>
              Fechar
            </button>
          </div>
        </div>
      </div>

      {showRescheduleModal && selectedSchedule && (
        <RescheduleModal
          schedule={selectedSchedule}
          patient={patient}
          onClose={handleCloseReschedule}
          onConfirm={(updated) => {
            console.log("Novo agendamento:", updated);
            onReschedule(updated);
            setShowRescheduleModal(false);
          }}
        />
      )}

      {showCancelModal && selectedSchedule && (
        <CancelModal
          schedule={selectedSchedule}
          patient={patient}
          onClose={handleCloseCancel}
          onConfirm={(payload) => {
            handleCancel(payload);
            console.log("Cancel payload", payload);
            removeSchedule(
              payload.canceledProcedures,
              payload.canceledSchedules
            );
          }}
        />
      )}

      {/* {showPaymentModal && selectedSchedule && (
        <PaymentModal
          schedule={selectedSchedule}
          patient={patient}
          onClose={handleClosePayment}
        />
      )} */}
    </>
  );
};

export default ScheduledProceduresModal;
